import useGetVehicles from '~/hooks/home/useGetVehicles';
import AppliedFilters from '~/services/common/contracts/AppliedFilters';

const freeShippingFilters: Partial<AppliedFilters> = {
  isFreeDelivery: true
};

export default function useGetFreeShippingVehicles() {
  const { vehicles, isLoaded } = useGetVehicles(
    freeShippingFilters,
    true,
    'Free Shipping Vehicles'
  );

  return { vehicles, isLoaded };
}
